/**
 * Main Gutenberg Content Block component
 */

import React from "react";
import parse from "html-react-parser";

// custom styles
import "../styles/main-content.css";

const MainContent = ({ content, props }) => {
  return (
    <>
      {!!content && (
        <article
          className="section content container m-section overflow-x-auto"
          itemScope
          key="content"
          id="content"
          itemType="http://schema.org/Article"
        >
          <section
            itemProp="articleBody"
            className={`parsed-content max-w-4xl mx-auto ${props?.classes || ""}`}
          >
            {parse(content)}
          </section>
        </article>
      )}
    </>
  );
};

export default MainContent;
